import { transliterateCyrillic } from '../../../../utils/utm/transliterateCyrillic'

/**
 * Brand name → latin slug with hyphens (same rules as functions/brands/brandSlug.js).
 */
export function slugifyBrandName(value = '') {
  const transliterated = transliterateCyrillic(String(value))
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

  return transliterated
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-+/g, '-')
}

export function isValidBrandSlug(slug) {
  if (typeof slug !== 'string' || !slug) return false
  return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug)
}

export function isBrandSlugTaken(slug, brands = [], excludeBrandId = '') {
  const normalized = String(slug || '')
  if (!normalized) return false

  return brands.some((brand) => {
    if (excludeBrandId && `${brand.id}` === `${excludeBrandId}`) return false
    return brand.slug === normalized
  })
}
